import * as React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Paper, InputBase, Divider, IconButton, Stack } from '@mui/material';
import { Close as CloseIcon, Search as SearchIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';
import Scan from './Scan';
import CheckDataProduct from '../js/CheckDataProduct';
import { startSpan } from './OpenTelemetry/OpenTelemetryProvider';

function Search({ location = 'navigationBar' }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [productCode, setProductCode] = React.useState(searchParams.get('search') || '');
  const { t } = useTranslation();

  const handleChange = (scanned) => {
    const span = startSpan('Search');
    span.setAttribute('Searched', scanned.code);
    span.setAttribute('Type', 'Scan');
    span.end();
    setProductCode(scanned.code);
    const lots = scanned.lots.map((lot) => `${lot.authority}:${lot.code}`).join(';');
    if (CheckDataProduct.isProductCode(scanned.code)) {
      navigate(`/products/${scanned.code}?search=${scanned.code}&lots=${lots}`);
      window.location.reload(true);
    } else navigate(`/products?search=${scanned.code}`);
  };

  const handleSubmit = () => {
    const span = startSpan('Search');
    span.setAttribute('Searched', productCode);
    span.setAttribute('Type', 'Manual');
    span.end();
    if (CheckDataProduct.isProductCode(productCode)) navigate(`/products/${productCode}?search=${productCode}`);
    else navigate(`/products?search=${productCode}`);
  };

  return (
    <Paper
      data-testid="Search"
      component="form"
      sx={{
        p: '5px',
        mx: '1%',
        flex: location === 'navigationBar' ? '1 1 68%' : '0 0 auto',
        width: location === 'home' ? { xs: '100%', sm: '90%', md: '70%', lg: '50%' } : 'auto',
        display: 'flex',
        alignItems: 'center',
        borderRadius: 24,
        border: '1px solid #dfe1e5',
        boxShadow: 'none',
        '&:hover': { boxShadow: '0 1px 6px rgb(32 33 36 / 28%)', borderColor: 'rgba(223,225,229,0)' },
      }}
      onSubmit={handleSubmit}
    >
      <IconButton sx={{ p: 1 }} type="submit">
        <SearchIcon />
      </IconButton>
      <InputBase sx={{ flexGrow: 1, fontSize: { xs: '14px', sm: '16px' } }} placeholder={t('products.research.form.placeholder')} required value={productCode} onChange={(e) => setProductCode(e.target.value)} />
      <Stack direction="row" alignItems="center" justifyContent="center">
        <IconButton type="button" sx={{ height: '40px', display: productCode ? 'block' : 'none' }} disabled={!productCode} onClick={() => setProductCode('')} data-testid="ClearButton">
          <CloseIcon />
        </IconButton>
        <Divider sx={{ height: '40px', display: productCode ? 'block' : 'none' }} orientation="vertical" />
        <Scan onChange={handleChange} />
      </Stack>
    </Paper>
  );
}

Search.propTypes = {
  location: PropTypes.string,
};

export default Search;
